import * as core from '../../../../../../../core'

import { query } from './communications-needed-by-department.query'

export const RESOURCE = {
  payload: {
    alias: 'communications.needed.by.department',
    description: 'Chart view of communications needed by department',
    name: 'Communications Needed by Department',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
